import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import { ClapService } from "../../../service/ClapService";
import { LinkProviderService } from "../../../service/LinkProviderService";
import { EditorialContentService } from "../../../service/EditorialContentService";
import { FieldBuilder } from "./../fields/FieldBuilder";
import "../clap/ClapNoticeInformation.scss";
import "../../../layout/styles/inline-cgos.css";


import { useDispatch, useSelector } from "react-redux";
import {
  setFiche,
  setIban,
  setMaxVal,
  setOptJustificatif,
  setPac,
} from "../../../store/actions/actionSociale";
import { ActionSocialeService } from "../../../service/ActionSocialeService";
import { AgentService } from "../../../service/AgentService";

export const SportNoticeInformation = ({ mode, hiddenNoticeButton, onConfirm }) => {
  const errors = {
    dod: 1,
    statut: 2,
    qf: 2,
    iban: 3,
    pac: 4,
    exercice:5,
    droits:6,
    siDossierValide:7,
  };

  const user = useSelector((state) => state.usager.user);
  const actionSociale = useSelector((state) => state.actionSociale);
  const [currentActionSociale, setCurrentActionSociale] = useState({});
  const [baremes, setBaremes] = useState([]);
  const [valParticipation, setValParticipation] = useState(0);
  const [enfants, setEnfants] = useState([]);
  const [displayBasic, setDisplayBasic] = useState(false);
  const [isJustificatifRequis, setIsJustificatifRequis] = useState();
  const [montantFrais, setMontantFrais] = useState();
  const [ibanMembre, setIbanMembre] = useState(null);
  const [enfantsAgeIntervalle, setEnfantsAgeIntervalle] = useState({});
  const [editorialContents, setEditorialContents] = useState([]);
  const [displayError, setDisplayError] = useState([]);

  const [hiddenButton, hideButton] = useState(hiddenNoticeButton);
  const dispatch = useDispatch();
  const history = useHistory();

  const actionSocialeService = new ActionSocialeService();
  const clapService = new ClapService();
  const agentService = new AgentService();
  const editorialContentService= new EditorialContentService();

  const linkService = new LinkProviderService();

  const  textAdressezVous="Pour en savoir plus ou si vous pensez qu'il y a une erreur, adressez-vous à votre ";

  if (!actionSociale || !actionSociale.cas || !actionSociale.exercice || actionSociale.listActionsSociale.length === 0) {
    history.push("/choixPeriodeSports/"+actionSociale.cas);
  }

  useEffect(() => {
    getCurrentActionSociale();
    getMontantFrais();
    getActivitiesEditorialContent();

    if(actionSociale.fiche.siNoFiche){
            setDisplayError(prevState => [...prevState, errors.exercice]);
     }else if(!actionSociale.fiche.siDodEncours) {

            if((actionSociale.exercice > actionSociale.fiche.exerciceDod) && !displayError.includes(errors.exercice)) { setDisplayError(prevState => [...prevState, errors.exercice]) }
            if((!actionSociale.fiche.droits.prestationSansCr ||
            ( ['1','2'].includes(user.codePosition) && !['1','3','6','2','7'].includes(user.codeSituationAdministrative)) ||
            ( ['3','4','5'].includes(user.codePosition) && (!['1','2','3'].includes(user.codeSituationAdministrative) ||
             (['2'].includes(user.codeSituationAdministrative) && ['4'].includes(user.codeSituationRetraite)) )) ||
            actionSociale.fiche.statutDod == '4' ) &&
             !displayError.includes(errors.droits)) { setDisplayError(prevState => [...prevState, errors.droits]) }
            if(actionSociale.fiche?.statutDod) {
              if(actionSociale.fiche.statutDod !== '3' && !displayError.includes(errors.statut)) { setDisplayError(prevState => [...prevState, errors.statut]) }
              else if(!actionSociale.fiche.droits.prestationSansCr && !displayError.includes(errors.qf)) { setDisplayError(prevState => [...prevState, errors.qf]) }
            } else if(!displayError.includes(errors.dod)) {
               setDisplayError(prevState => [...prevState, errors.dod]);
            }
            if(!actionSociale.fiche.siDossierValide && !displayError.includes(errors.siDossierValide)){
              setDisplayError(prevState => [...prevState, errors.siDossierValide]);
            }

     }

     getIsJustificatifRequis();
     getIbanMembre();
     getAgentEnfants();

  }, []);

  useEffect(() => {
    dispatch(setOptJustificatif(isJustificatifRequis));
  }, [isJustificatifRequis]);

  useEffect(() => {
    dispatch(setMaxVal(valParticipation));
  }, [valParticipation]);

  useEffect(() => {
    dispatch(setIban(ibanMembre));
  }, [ibanMembre]);

  useEffect(() => {
    dispatch(setPac(enfants));
  }, [enfants]);

  const getCurrentActionSociale = () => {
    Object.values(actionSociale.listActionsSociale).forEach((as) => {
      if (
        as.codeActionSociale === actionSociale.cas &&
        as.exercice === actionSociale.exercice
      ) {
        setCurrentActionSociale(as);
        getBaremes(as);
        getEnfantsAgeIntervalle(as);
        return;
      }
    });
  };

  //4) Recuperration des baremes
  const getBaremes = async (actionSocial) => {
    const bareme = {
      casCode: actionSocial.codeActionSociale,
      delegId: actionSocial.codeDelegation,
      exercie: actionSocial.exercice,
      siActif: 1,
    };

    try {
      const { data } = await clapService.getBaremes(bareme);
      setBaremes(data);
      getValeurParticipation(data);
      if(actionSocial.fiche) await getIsJustificatifRequis();
    } catch (error) {
      console.log(error);
    }
  };

  const getValeurParticipation = (tranches) => {
    let val = 0;
    tranches.forEach((el, i) => {
      if (val !== 0) return;

      if (i === tranches.length - 1) {
        if (Number(actionSociale.fiche.quotientFamilial) >= Number(el.borne)) {
          val = tranches[i].valeur;
        }
      } else if (Number(actionSociale.fiche.quotientFamilial) < Number(tranches[i + 1].borne)) {
        val = el.valeur;
      }
      if(actionSociale.fiche.quotientFamilial == null){
        val = tranches[tranches.length-1].valeur;
      }
      setValParticipation(val);
    });
  };

  const getIsJustificatifRequis = async () => {
    try {
      const { data } = await clapService.getJustificatifForClapNoticeInfo(
          actionSociale.fiche.numCgos,
          actionSociale.fiche.codeSituationAdministrative,
          actionSociale.fiche.codePosition
      );
      setIsJustificatifRequis(data);
    } catch (error) {
      console.log(error);
    }
  };

  //Récuperation de l'IBAN de l'agent
  const getIbanMembre = async () => {
    try {
      const { data } = await clapService.getIbanMembre(user.numCgos);
      setIbanMembre(data.numIBan);
      if(!actionSociale.fiche.siDodEncours){
       if(!data.numIBan && !displayError.includes(errors.iban)) setDisplayError(prevState => [...prevState, errors.iban]);
      }
    } catch (error) {
      setDisplayError(prevState => [...prevState, errors.iban])
    }
  };

  //recup me montant frais
  const getMontantFrais = () => {
         actionSocialeService.getMontantMinimumDeFrais(actionSociale.cas, user.codeDelegation ,actionSociale.exercice)
         .then((res) => {
               setMontantFrais(res.data);
               actionSocialeService.persistMontantMinFrais(res.data);
            }
         )
          .catch((error) => {
            console.log("error", error);
          });
  };

  const getAgentEnfants = () => {
    // Il n'ya pas de vérification d'enfants pour la prestation vavances adultes et familles (cas = 3742)
    if(actionSociale.cas === "3743"){
      agentService.getAgentEnfants(actionSociale.fiche.numCgos, actionSociale.fiche.codeDelegation, actionSociale.cas, actionSociale.exercice).then((res) => {
        let items = [];
        res.data.forEach((e) => items.push(e));
        setEnfants(items);        
          if(items.length === 0 && !displayError.includes(errors.pac)) setDisplayError(prevState => [...prevState, errors.pac]);        
      }).catch((err) => {
        setDisplayError(prevState => [...prevState, errors.pac]);
      });
    }
  };

  const getEnfantsAgeIntervalle = async (actionSocial) => {
    try {
      const { data } = await agentService.getEnfantsParamIntervalle(
          actionSocial.codeDelegation,
          actionSocial.codeActionSociale,
          actionSocial.exercice
      );
      setEnfantsAgeIntervalle(data);
    } catch (error) {
      console.log(error);
    }
 };

 //Récuperation des paramétrage des activtés(content edito) (auth et not aut)
  const getActivitiesEditorialContent = async () => {
     try{
        const { data } = await editorialContentService.getEditorialContent(
          user.codeDelegation,
          actionSociale.cas,
          actionSociale.exercice
      );
      setEditorialContents(data);
    } catch (error) {
      console.log(error);
    }
  };


  const nextStep = () => {
    actionSocialeService.persistState(actionSociale);
    onConfirm(false);
    hideButton(true);
  };

  const getDateFormat = (date) => {
    return new Date(date).toLocaleDateString("fr-FR", {});
  };

  return (
    <div className="grid">
      <ChequeCultureLegacy />
      <div className="col-12 mx-auto">
        <div className="no_shadow_no_border card " style={{ display: !displayBasic ? "block" : "none" }}>
           {actionSociale.fiche.siDodEncours && (

              <div className="alert alert-success" style={{textAlign:"center"  }}>
                <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif" }}>Votre dossier C.G.O.S { actionSociale.exercice } est en cours de traitement.<b> Votre demande de prestation sera étudiée après l’ouverture de vos droits.</b> <p>Votre quotient familial sera calculé si vous avez joint votre avis d’impôt sur les revenus.</p></span>
              </div>
           )}
           {(displayError.includes(errors.exercice) || displayError.includes(errors.droits) || displayError.includes(errors.dod) || displayError.includes(errors.siDossierValide) ) && (
                         <div className="alert alert-danger" style={{textAlign:"center"  }}>
                         <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif"}}>Vous ne pouvez pas demander cette prestation car <b>le contenu ou le statut actuel de votre dossier C.G.O.S ne le permet pas ou pas encore.</b> <p> Actualisez votre dossier depuis la rubrique
                            <a href={linkService.getRetourEaSaisieDossier()} target="_blank"> Dossier C.G.O.S en ligne</a>. </p><p> {textAdressezVous}<a href={'https://www.cgos.info/'+user.codeDelegation+'/nous-contacter/'} target="_blank"> contact C.G.O.S</a></p> </span>
                          </div>
            )}
{/*           {(displayError.includes(errors.dod))  && (
              <div className="alert alert-danger">
              <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif", }}>Le statut actuel de votre dossier C.G.O.S { actionSociale.exercice } ne vous permet pas d’accéder aux formulaires de demande de prestations. Consultez et ou actualisez le statut de votre dossier depuis la rubrique
                <a href={linkService.getRetourEaSaisieDossier()} target="_blank"> Dossier C.G.O.S en ligne</a>.</span>
              </div>
          )} */}
          {(displayError.includes(errors.statut) && !(displayError.includes(errors.exercice) || displayError.includes(errors.droits) )) && (
              <div className="alert alert-danger" style={{textAlign:"center"  }}>
              <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif",}}>Vous devez
                <a href={linkService.getRetourEaSaisieDossier()} target="_blank"> compléter votre dossier annuel C.G.O.S</a> en ligne pour pouvoir accéder à cette demande de prestation.</span>
              </div>
          )}
          {(displayError.includes(errors.qf) && !(displayError.includes(errors.exercice) || displayError.includes(errors.droits))) && (
              <div className="alert alert-danger" style={{textAlign:"center"  }}>
              <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif", }}>
                <a href={linkService.getRetourEaMembreDroits()} target="_blank">Vos droits</a> ouverts pour l'année {actionSociale.exercice} ne vous permettent pas d’accéder aux prestations versées selon le quotient familial C.G.O.S.
            </span>
              </div>
          )}
          {displayError.includes(errors.iban) && (
            <div className="alert alert-danger" style={{textAlign:"center"  }}>
              <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif", }}>
                Vous ne pouvez pas demander cette prestation car <b>vous n’avez pas fourni de relevé d’identité bancaire (IBAN) au C.G.O.S.</b>
                <p>Nous vous invitons à nous l’adresser depuis la rubrique
                <a href={linkService.getRetourEaContacterNousChangeSituations()} target="_blank">
                  {" "}« Nous contacter - Changement de situation »{" "}
                 </a></p>
              </span>
            </div>
          )}
          {(displayError.includes(errors.pac) && !(displayError.includes(errors.exercice) || displayError.includes(errors.droits) ))&& (
            <div className="alert alert-danger" style={{textAlign:"center"  }}>
              <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif", }}>
                Vous ne pouvez pas demander cette prestation car <b>il n’y a pas d’enfants enregistrés ou éligibles dans votre dossier C.G.O.S</b> de l’année concernée.
                <p> S’il s’agit d’une erreur, adressez-vous à votre
                <a href={linkService.getRetourEaContacterNous()} target="_blank">
                  {" "}contact C.G.O.S{" "}
                </a></p>
              </span>
            </div>
          )}

         {currentActionSociale?.codeActionSociale == "3743" &&
          
            <span
              style={{
                fontSize: "10.0pt",
                fontFamily: "Tahoma, sans-serif",
              }}
            >
            <p></p>
            Le C.G.O.S verse cette  prestation pour <b>participer aux dépenses pour mes enfants occasionnées dans le cadre
            d'un abonnement ou d'une adhésion à un club, une association ou un autre organisme</b> (pas de durée minimum d'adhésion) :

              <FieldBuilder code={'NEA_NOTICE_ACTIVITIES'} items={[editorialContents,currentActionSociale.codeActionSociale]} />

            </span>
          }
          {currentActionSociale?.codeActionSociale == "3743" &&
           <h2 className="cld-h2">Bénéficiaire</h2>
          }
          {currentActionSociale?.codeActionSociale == "3743" &&
          <p><b> Mon enfant: </b> </p>
          }
          {currentActionSociale?.codeActionSociale == "3743" &&
          <ul>
            <span
              style={{
                fontSize: "10.0pt",
                fontFamily: "Tahoma, sans-serif",
              }}
            >
              <li>
                Doit être à ma charge fiscale ou en résidence alternée.
              </li>
              <li>
                 Doit avoir entre {enfantsAgeIntervalle.minValue} ans et moins de {enfantsAgeIntervalle.maxValue} ans au 1 er janvier de l’année {actionSociale.exercice}.
              </li>
              <li>
                 S'il est en situation de handicap avec un taux supérieur ou égal à 80%,  il peut bénéficier de la prestation sans limite d’âge.
              </li>
              </span>
          </ul>}

          {currentActionSociale?.codeActionSociale == "3742" &&
          
            <span
              style={{
                fontSize: "10.0pt",
                fontFamily: "Tahoma, sans-serif",
              }}
            >

              <p>
                 Le C.G.O.S verse cette prestation pour <b>participer à mes dépenses personnelles</b> (les membres de la famille ne peuvent pas en bénéficier) occasionnées:
              </p>
              <ul>
                <li>
                   <b>Pour la pratique d'une activité sportive, culturelle ou de loisirs,</b>
                </li>
                <li>
                    Dans le cadre d’un <b>abonnement</b> ou d’une <b>adhésion,</b>
                 </li>
                <li>
                    Et dispensées par<b> un club, une association, une fédération, une salle de sports, un centre socio-culturel,</b>
                </li>
              </ul>
                <FieldBuilder code={'NEA_NOTICE_ACTIVITIES'} items={[editorialContents,currentActionSociale.codeActionSociale]} />
              </span>
          }

          <h2 className="cld-h2">Montants versés</h2>
          <p className="cld-p">
            <span
              style={{
                fontSize: "10.0pt",
                fontFamily: "Tahoma, sans-serif",
              }}
            >

              {currentActionSociale?.codeActionSociale == "3743" &&
              <div><p>Chaque année,</p>
                 <ul>
                    <li> <b>Chacun de mes enfants peut bénéficier de la prestation.</b></li>
                    <li> Le montant du versement dépend <b>des frais que j’ai engagés,</b></li>
                    <li> Dans la limite du <b>montant maximum prévu</b> pour <b>mon quotient familial C.G.O.S.</b></li>
                </ul></div>
              }
              {currentActionSociale?.codeActionSociale == "3742" &&
                <div><p>Chaque année,</p>
                <ul>
                  <li>Le montant du versement dépend <b>des frais que j’ai engagés,</b></li>
                  <li>Dans la limite du <b>montant maximum prévu</b> pour <b>mon quotient familial C.G.O.S.</b></li>
                </ul></div>
              }
            </span>
          </p>

          {actionSociale.fiche.siDodEncours && (
          <div className="cld-p">
            <ul>
              <span
                style={{
                  fontSize: "10.0pt",
                  fontFamily: "Tahoma, sans-serif",
                }}
              >
              <p></p>
              <li>
                <b>Tant que vos droits ne sont pas ouverts</b>, le <b>quotient familial</b> affiché <b>est</b> <b>« non connu »</b> car pas encore calculé.<br></br>
                Si tel est le cas, <b>vous pouvez quand même envoyer votre demande</b> sans cette information. <br></br>
                Votre QF et le montant de la participation du C.G.O.S seront automatiquement mis à jour avant l'étude de votre demande.
              </li>
              </span>
            </ul>
          </div>
           )}

          <table className="cld-table">
            <thead>
              <tr>
                <th>Tranche de quotient familial de référence</th>
                {currentActionSociale?.codeActionSociale == "3743" &&
                  <th>Montant annuel maximum par enfant</th>
                }
                {currentActionSociale?.codeActionSociale == "3742" &&
                  <th>Montant annuel maximum de la participation du CGOS</th>
                }
              </tr>
            </thead>
            <tbody>
              {baremes.map((el, i) => {
                let borne = "";
                if (i >= 0 && i < baremes.length - 1) {
                  const borneToNumber = Number(baremes[i + 1].borne).toFixed(0);
                  borne = `de ${el.borne} à ${borneToNumber}`;
                } else {
                  borne = `supérieur à ${Number(el.borne).toFixed(
                    0
                  )} ou non connu`;
                }
                return (
                  <tr key={i}>
                    <td>{borne}</td>
                    <td>{el.valeur} €</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <p></p>
          {!actionSociale.fiche.siDodEncours && (
          <table className="cld-table-2">
            <thead>
              <tr>
                <th>Mon quotient familial</th>
                {currentActionSociale?.codeActionSociale == "3743" &&
                  <th>Montant annuel maximum par enfant</th>
                }
                {currentActionSociale?.codeActionSociale == "3742" &&
                  <th>Montant annuel maximum de la participation du CGOS</th>
                }
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {actionSociale.fiche.quotientFamilial == null? "non connu" : actionSociale.fiche.quotientFamilial.toString().replace('.', ',')}
                </td>
                <td>
                  {baremes.length > 0 && actionSociale.fiche.quotientFamilial == null ? baremes[baremes.length-1].valeur : valParticipation} €
                </td>
              </tr>
            </tbody>
          </table>
          )}
          <div className="info-wrapper">
            <span
              style={{
                fontSize: "12.0pt",
                fontFamily: "Tahoma, sans-serif",
              }}
            >
              Documents à préparer pour ma demande
            </span>
          </div>

          {currentActionSociale?.codeActionSociale == "3743" && (
              <div class="card-justificatif">
                <div class="card-justificatif-body">
                <div class="card-justificatif-img" style={{width: "13%", marginRight: "1%"}}>
                    <img src="/assets/image/DOC-1.png" />
                  </div>
                  <div class="card-justificatif-txt-container" style={{width: "85%"}}>
                    <div class="card-justificatif-titre pt-2">
                      <span
                        style={{
                          fontSize: "9.0pt",
                          fontFamily: "Tahoma, sans-serif",
                        }}
                      >
                        Facture, reçu ou attestation de paiement de l'activité pratiquée
                      </span>
                    </div>
                    <div class="card-justificatif-description">
                      <span
                        style={{
                          fontSize: "9.0pt",
                          fontFamily: "Tahoma, sans-serif",
                        }}
                      >
                        Avec le prénom et le nom de l'enfant, l'actvité pratiquée, l'organisme ou l'association agrée, la période et le montant de l'abonnement ou de la cotisation payée.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
           {currentActionSociale?.codeActionSociale == "3743" && (
              <div class="card-justificatif">
                <div class="card-justificatif-body">
                <div class="card-justificatif-img" style={{width: "13%", marginRight: "1%"}}>
                    <img src="/assets/image/DOC-1.png" />
                  </div>
                  <div class="card-justificatif-txt-container" style={{width: "85%"}}>
                    <div class="card-justificatif-titre pt-2">
                      <span
                        style={{
                          fontSize: "9.0pt",
                          fontFamily: "Tahoma, sans-serif",
                        }}
                      >
                        Attestation de l'organisme au nom et prénom de l'enfant (conditionnelle)
                      </span>
                    </div>
                    <div class="card-justificatif-description">
                      <span
                        style={{
                          fontSize: "9.0pt",
                          fontFamily: "Tahoma, sans-serif",
                        }}
                      >
                        Dans le cas où l'enfant ne figure pas sur la facture, je dois transmettre en plus une attestation au nom et prénom de l'enfant, signée et tamponnée par l'organisme ou l'association en charge de l'activité.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}

          {currentActionSociale?.codeActionSociale == "3742" && (
              <div class="card-justificatif">
                <div class="card-justificatif-body">
                  <div class="card-justificatif-img" style={{width: "13%", marginRight: "1%"}}>
                    <img src="/assets/image/DOC-1.png" />
                  </div>
                  <div class="card-justificatif-txt-container" style={{width: "85%"}}>
                    <div class="card-justificatif-titre pt-2">
                      <span
                        style={{
                          fontSize: "9.0pt",
                          fontFamily: "Tahoma, sans-serif",
                        }}
                      >
                        Facture, reçu ou attestation de paiement de l'activité pratiquée
                      </span>
                    </div>
                    <div class="card-justificatif-description">
                      <span
                        style={{
                          fontSize: "9.0pt",
                          fontFamily: "Tahoma, sans-serif",
                        }}
                      >
                       A mon nom avec l'activité pratiquée, l'organisme ou l'association agrée, la période et le montant de l'abonnement ou de la cotisation payée.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
             )}
            
          {isJustificatifRequis && (
            <div class="card-justificatif">
              <div class="card-justificatif-body">
                <div class="card-justificatif-img" style={{width: "13%", marginRight: "1%"}}>
                  <img src="/assets/image/DOC.png" />
                </div>
                <div class="card-justificatif-txt-container" style={{width: "85%"}}>
                  <div class="card-justificatif-titre pt-2">
                    <span
                      style={{
                        fontSize: "9.0pt",
                        fontFamily: "Tahoma, sans-serif",
                      }}
                    >
                      Justificatif de présence en établissement
                    </span>
                  </div>
                  <div className="card-justificatif-description">
                  <ul
                    style={{
                      listStyleType: "disc",
                      listStylePosition: "inside",
                      padding: 0,
                      margin: 0,
                      fontSize: "9.0pt",
                      fontFamily: "Tahoma, sans-serif",
                    }}
                  >
                    <li style={{ marginBottom: "4px" }}>
                      Bulletin de paie ou attestation de travail de moins d’un mois.
                    </li>
                    <li>
                      Décision administrative de congés parental à 100%.
                    </li>
                  </ul>
                </div>

                </div>
              </div>
            </div>
          )}
          <div className="tutorial">
            <img className="tutorial-image" src="/assets/icon_youtube.png" />{" "}
            <a
              target="_blank"
              href="https://www.youtube.com/watch?v=rQzzWn7Yz-o"
            >
              <span
                style={{
                  fontSize: "10.0pt",
                  fontFamily: "Tahoma, sans-serif",
                }}
              >
                # TutorielCGOS - Comment scanner un document
              </span>
            </a>
          </div>
          <div className="info-wrapper">
            <span
              style={{
                fontSize: "12.0pt",
                fontFamily: "Tahoma, sans-serif",
              }}
            >
              Comment m'y prendre
            </span>
          </div>
          <p className="cld-c">


          {currentActionSociale?.codeActionSociale == "3743" &&
                <p> <b> Je dois me limiter à une seule demande par an et par enfant </b>, </p>
          }
          {currentActionSociale?.codeActionSociale == "3742" &&
                <p> <b> Je dois me limiter à une seule demande par an. </b> </p>
          }

          <p>Je peux indiquer plusieurs activités à la fois.</p>

          {editorialContents.filter(item => item.code === "CIVIL" || item.code === "SCOLAIRE")
              .map(filteredItem => (
                <p><b>{filteredItem.rawHtml}</b></p>
              ))
          }


          <p>Pour que ma demande soit prise en compte, </p>{" "}
          <ul>
            <span
              style={{
                fontSize: "10.0pt",
                fontFamily: "Tahoma, sans-serif",
              }}
            >
              <li>
                <b>Je dois envoyer la ou les factures correspondant à ma demande</b>,
              </li>
              <li>
                Mes frais à rembourser doivent être au minimum de {montantFrais} euros (je peux cumuler plusieurs factures si nécessaire),
              </li>
              <li>
                <b>Je dois avoir déjà transmis mon Dossier C.G.O.S annuel.</b>
              </li>
            </span>
          </ul>
          </p>
          {!hiddenButton && (
            <div className="cld-dem">
              <br></br>
              <h1
                style={{
                  color: "#676767",
                  fontWeight: "bold",
                  fontSize: "15.0pt",
                  fontFamily: "Tahoma, sans-serif",
                  textAlign: "center",
                }}
              >
                CETTE DEMARCHE PREND 5 MINUTES
              </h1>
              <br></br>
              <div className="next-button-wrapper">
                 { displayError.length > 0
                                 ? <button type="button" className="disabled" style={{ pointerEvents: "none" }}> ENVOYER UNE DEMANDE EN LIGNE </button>
                                 : <button type="button" className="btn_submit_modal" onClick={nextStep}> ENVOYER UNE DEMANDE EN LIGNE </button>}
              </div>
              <br></br>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
